module.exports = __webpack_public_path__ + "static/media/needle-loader-white.2e462866.gif";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Img/needle-loader-white.gif
// module id = 869
// module chunks = 0